import React from 'react';
import { Card } from '../styles/styled_predict_table';
import {MatchContainer} from '../styles/styled_predict_table';

export default function Match(props){
  const { match, match_confidence } = props.props
  const matchCalc = (match, match_confidence) => {
    let percent_match;
    let matchType;
    if(match == 1){
      percent_match =  match_confidence * 100
      matchType = true
    } else {
      percent_match = (1 - match_confidence) * 100
      matchType = false
    }
    //set style based on match 0/1 red or green.
    let rounded = percent_match.toFixed(2)
    let formatted = rounded.toString() + "%"
    return [formatted, matchType]
  }
  let format_type = matchCalc(match, match_confidence)
  let calc_match = "Match Confidence:" + " " + format_type[0]

  return(
    <MatchContainer>
      <Card match={format_type[1]} >

        {calc_match}

      </Card>
    </MatchContainer>
  )
}
